import { render } from "./TextAreaComponent.vue?vue&type=template&id=238a4d3d&scoped=true"
import script from "./TextAreaComponent.vue?vue&type=script&lang=js"
export * from "./TextAreaComponent.vue?vue&type=script&lang=js"

import "./TextAreaComponent.vue?vue&type=style&index=0&id=238a4d3d&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238a4d3d"]])

export default __exports__